import { LRUCache } from 'lru-cache'
import { AbiItem, Address } from 'viem'

import { config } from '@/constants'
import * as CONTRACTS from '../contracts'

type ContractHelper = {
  abi: AbiItem[]
  address?: Address
  functionName?: string
  name: string
}

const cache = new LRUCache({
  max: 500,
  ttl: 1000 * 60 * 5,
})

// get all functions names from a contract.abi
export const getAbiFunctions = (abi: any) => {
  return abi
    .filter((item: any) => item.type === 'function')
    .map((item: any) => item.name)
}

/**
 * Get Contract By function name
 * @param name
 * @returns
 */
export const getContractByFunctionName = (name: string): ContractHelper => {
  // // Check if the result is already in the cache
  if (cache.has(name)) {
    return cache.get(name) as ContractHelper
  }

  // Loop over all properties of contracts
  for (const [key, value] of Object.entries(CONTRACTS)) {
    // Check if the contract has the function name
    if (getAbiFunctions(value.abi).includes(name)) {
      const result = {
        abi: value.abi,
        address: config.ADDRESS[key as keyof typeof config.ADDRESS], // Add the index signature to allow indexing with a string
        functionName: name,
        name: key,
      }

      if (!key) {
        throw new Error(`Function ${name} not found in any contract`)
      }

      // Add the result to the cache
      cache.set(name, result)

      return result as ContractHelper
    }
  }

  throw new Error(`Function ${name} not found in any contract`)
}

export const getContractByName = (
  name: keyof typeof config.ADDRESS
): ContractHelper => {
  // // Check if the result is already in the cache
  if (cache.has(name)) {
    return cache.get(name) as ContractHelper
  }

  // Get the Contract Address
  const address = config.ADDRESS[name as keyof typeof config.ADDRESS]
  // Get the Contract ABI
  const abi = CONTRACTS[name as keyof typeof CONTRACTS]?.abi

  if (!abi) {
    throw new Error(`Contract ${name} not found`)
  }

  const result = {
    abi,
    address,
    name,
  }

  // Add the result to the cache
  cache.set(name, result)

  return result as ContractHelper
}
